module.exports = __webpack_public_path__ + "img/lianminglogo.6deb15f0.png";